import { render } from "./index.vue?vue&type=template&id=488e125e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/banners-detail/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "488e125e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('488e125e', __exports__)) {
    api.reload('488e125e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=488e125e", () => {
    api.rerender('488e125e', render)
  })

}


export default __exports__